import React from "react";
import { TRANSFORMATION } from "../data/siteData";
import ServicePage from "./ServicePage";

export default function TransformationPage({ onNavigate }) {
  return (
    <ServicePage hero={TRANSFORMATION.hero} onNavigate={onNavigate}>
      <section className="section">
        <div className="capability-grid">
          {TRANSFORMATION.pillars.map((p, i) => (
            <div key={i} className="capability-card">
              <div className="capability-card-header">
                <h4>{p.title}</h4>
                <span className="capability-icon">{p.icon}</span>
              </div>
              <p>{p.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </ServicePage>
  );
}
